module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select8.72d7ceaf.png";